import { styled } from 'styled-components';

export const Avatar = styled.div`
  border-radius: 50%;
  height: 24px;
  margin-right: 8px;
  width: 24px;
`;

export const CommentHeading = styled.div`
  column-gap: ${({ theme }) => theme.spacing.space02};
  display: flex;
  margin-bottom: 5px;
  width: 100%;

  & > ${Avatar} {
    flex-shrink: 0;
  }
`;
